<template>
  <td class="text-neutral-40 whitespace-nowrap text-sm" :class="{ 'text-right': rightAligned }">
    <slot></slot>
  </td>
</template>

<script>
export default {
  name: "SimpleTableCell",
  props: {
    rightAligned: { type: Boolean, default: false },
  },
};
</script>
